module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-72x72-precomposed-f6dcba83.png";